import { Outlet } from 'react-router-dom';

export default function WithoutNavLayout() {
  return (
    <div className="pt-4">
      <Outlet />
    </div>
  );
}
